import React from "react";
import Routes from "./routes";
import "react-toastify/dist/ReactToastify.css";

// O tema (claro/escuro, cores, fontes, idioma pt-BR) fica todo em
// context/DarkMode, que envolve as rotas. Antes havia um segundo
// ThemeProvider aqui fora: com dois temas aninhados o Material-UI passa a
// gerar classes com número no final ("MuiTab-root-123"), e nenhum estilo do
// sistema escrito como ".MuiTab-root" funcionava.
const App = () => <Routes />;

export default App;
